import { styled } from '@mui/material';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

export const StyledDateTimePicker = styled(MobileDateTimePicker)((props: { isCompact?: boolean }) => `
  ${props.isCompact && 'div > input { padding: 2px 4px!important; }'}
`);
